
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import TooltipMaterials from "@/components/tooltip/moduleResult.vue";
import CandidateAnswerSection from "./candidate-answer-section-module.vue";
import SvgImgV3 from "@/components/videoPaly/video-play-v3.vue";
import AudioStyle from "@/components/videoPaly/audioStyle.vue";
import Replenish from "./replenish/index.vue";
import {
  CandidateNewResult,
  QuestionConfig
} from "@/lib/model/exam/candidate-result";

@Component({
  components: {
    TooltipMaterials,
    CandidateAnswerSection,
    SvgImgV3,
    AudioStyle,
    Replenish
  }
})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  connectCode = "";
  showAiQuestion = true; //ai回答记录展开收起
  questionIndexAppendIndex = {}; //正在播放的回答视频 { 题号: 追问index }
  playTime = 0; // 记录答案播放进度
  lastPlayVideoIndex = -1; // 最后播放的视频序号

  get questionList() {
    return this.all.report.questionList.filter(q =>
      [1, 7, 6, 8, 5].includes(q.questionType)
    );
  }

  get isStudent() {
    return false;
  }

  mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    document.addEventListener("fullscreenchange", this.checkFullscreen);
  }

  //全屏视频修改填充样式
  isVideoFullscreen = false;
  get objectFit() {
    return this.isVideoFullscreen ? "contain" : "cover";
  }

  getFirstAnswer(question: QuestionConfig) {
    return question.answer.messages?.find(item => item.role === "candidate");
  }

  getAppendAnswer(question: QuestionConfig) {
    const candidateIdx = question.answer.messages?.findIndex(
      item => item.role === "candidate"
    );
    return question.answer.messages?.slice(candidateIdx + 1);
  }

  checkFullscreen() {
    this.isVideoFullscreen =
      document.fullscreenElement !== null &&
      document.fullscreenElement.tagName === "VIDEO";
  }
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.checkFullscreen);
  }

  // tooltip音频播放
  playAudioDesc(q: QuestionConfig) {
    // 存在音频列表
    const audioList: HTMLAudioElement[] = [];
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audioElement: HTMLAudioElement, i: number) => {
      if (
        !audioList.find(
          (audio: HTMLAudioElement) => audio.id === audioElement.id
        )
      ) {
        audioList.push(audioElement);
      }
      audioElement.pause();
    });
    this.stopAllMp3StatusIcon();
  }
  stopAllMp3StatusIcon() {
    const mp3Player = this.$refs["tooltipMaterials"] as [];
    if (mp3Player?.length) {
      mp3Player.forEach((player: any) => {
        player.isPlaying = false;
      });
    }
  }

  timeupdate({ target }: Event, answerIndex: number) {
    this.playTime = (target as HTMLMediaElement).currentTime * 1000;
    this.lastPlayVideoIndex = answerIndex;
  }

  onClickAsrItem(data: {
    answerIndex: number;
    appendIndex: number;
    time: number;
  }) {
    const candidateAnswerSection = this.$refs[
      "candidateAnswerSection" + data.answerIndex
    ] as any;
    if (candidateAnswerSection && candidateAnswerSection.length > 0) {
      const that = candidateAnswerSection[0];
      const refName = "PCvideo-" + data.answerIndex;
      const mainName = "PCvideo-1" + data.answerIndex; // 主回答
      this.questionIndexAppendIndex[data.answerIndex] = data.appendIndex;
      try {
        // 找到this.$refs中所有PCvideo-开头的元素，除要播放的以外的全部停止
        for (const key in that.$refs) {
          const element = that.$refs[key];
          if (key.indexOf("PCvideo-") === 0 && key !== refName) {
            Array.from(element).forEach((item: any) => {
              item.pause();
            });
          }
          if (key.indexOf("PCvideo-1") === 0 && key !== refName) {
            element.pause();
          }
        }
        //当前题目播放器
        let videoPalyer = that.$refs[mainName];
        if (data.appendIndex !== -1 && that.$refs[refName]) {
          videoPalyer = that.$refs[refName][data.appendIndex];
        }

        if (!videoPalyer) return;
        videoPalyer.currentTime = data.time / 1000 + 0.01; // 这个地方+0.01防止上一句话闪一下
        videoPalyer.play();
      } catch (e) {
        console.log(e);
      }
    }
  }
  // 自动播放下一个追问
  onEnded(questionIndex: number) {
    const questionLen = this.getAppendAnswer(this.questionList[questionIndex])
      ?.length;

    if (!questionLen) return;

    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;

    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex + 1,
        time: 0
      });
    }
  }
  //前一个追问
  preAppend(questionIndex: number) {
    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;

    if (appendIndex > -1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex - 1,
        time: 0
      });
    }
  }
  //下一个追问
  nextAppend(questionIndex: number) {
    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;
    const questionLen = this.getAppendAnswer(this.questionList[questionIndex])
      ?.length;

    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex + 1,
        time: 0
      });
    }
  }

  getBlankQuestion(q: number) {
    const textList = this.all.report.questionList[q].desc
      .replace(/（）/g, "()")
      .split("()");

    const first = textList.shift();

    return textList.reduce((prev, item, index) => {
      return prev + `<span class="blank"> {填空${index + 1}} </span>` + item;
    }, first);
  }

  getAIComment(aiComment: any) {
    return aiComment.replaceAll("\n", "<br/>");
  }

  // mp3不展示居中播放按钮
  isShowSvg(val: string) {
    return (
      val &&
      String(val)
        .substr(-3, 3)
        .toLowerCase() !== "mp3"
    );
  }
}
